export const DIALOG_WIDTH = 310;
